import React, { useEffect } from "react";
import { useLanguageContext } from "../context/LanguageContext";
import { useUpdateContext } from "../context/UpdateContext";
import { FaSquareXTwitter } from "react-icons/fa6";

const Homepage: React.FC = () => {
    const { setDidUpdate } = useUpdateContext();
    const { isHE } = useLanguageContext();
    const currentUpdate = "2025-01-13";

    useEffect(() => {
        const manualDate = new Date(currentUpdate);
        const localStorageKey = "lastUpdate";

        const storedDateString = localStorage.getItem(localStorageKey) || "2024-12-01"; // Default initial value
        const storedDate = new Date(storedDateString);

        if (manualDate > storedDate) {
            setDidUpdate(true);
            localStorage.setItem(localStorageKey, currentUpdate);
        }
    }, [currentUpdate, setDidUpdate]);

    return (
        <div className="h-full flex flex-col justify-around bg-homepage">

            <div 
            className={
                isHE ?
                "flex flex-col-reverse justify-between md:flex-row" :
                "flex flex-col justify-between md:flex-row"

            }>
                <div className="basis-1/3 flex flex-col mt-0.5 ">
                    {!isHE ? (
                        <>
                            <h1
                                className="text-2xl mx-3"
                                style={{ color: "#F88158" }}
                            >Hoops Boarding Gate</h1>
                            <h2 className="text-lg mt-2">
                                <span
                                    className="mx-2"
                                    style={{ color: "#F88158" }}
                                >
                                    Destination:
                                </span>
                                <span>
                                    <span>
                                        &nbsp;
                                    </span>
                                    <span
                                        className="bg-nba-gradient border-2 p-0.5 border-gray-500 rounded"
                                    >
                                        NBA
                                    </span>

                                </span>

                            </h2>
                            <div className="w-svw mt-5 md:w-5/6">
                                <p className="mx-5 mb-3 text-justify text-white">
                                    Your gateway to prospect evaluations from all over the NBA Draft comuunity, along with accumulated data on past evaluations of Draft Analysts!
                                </p>
                            </div>
                        </>
                    ) : (
                        <div dir="rtl">
                            <h3
                                className="text-xl font-semibold mt-3"
                                style={{ color: "#F88158" }}
                            >עדכונים אחרונים
                            </h3>
                            <ul className="text-white text-sm text-right mr-3 mt-5">
                            <li className="mb-3">
                                    <span className="font-bold">
                                        2.1.25:
                                    </span>&nbsp;
                                הועלה הפרופיל של קספארס יאקוצ'יוניס
                                </li>
                            <li className="mb-3">
                                    <span className="font-bold">
                                        2.1.25:
                                    </span>&nbsp;
                                הועלה הפרופיל של ייגור דמין
                                </li>
                            <li className="mb-3">
                                    <span className="font-bold">
                                        30.12.24:
                                    </span>&nbsp;
                                הועלה הפרופיל של אייס ביילי
                                </li>
                                <li className="mb-3">
                                    <span className="font-bold">
                                        22.12.24:
                                    </span>&nbsp;
                                עדכונים לפרופיל של קופר פלאג
                                </li>
                                <li className="mb-3">
                                <span className="font-bold">
                                        14.12.24:
                                    </span>&nbsp;
                                    עדכונים לפרופיל של דילן הארפר
                                </li>
                                <li>
                                    <span className="font-bold">
                                        1.12.24:
                                    </span>&nbsp;
                                    האתר הושק עם פרופיל של בן שרף!
                                </li>
                            </ul>
                        </div>
                    )
                    }
                </div>
                <div className="basis-1/3 h-1/12 mx-2 rounded">
                    <img
                        src="../assets/bg.png"
                        className="object-scale-down rounded"
                    />
                </div>
                <div className="basis-1/3 flex flex-col mt-0.5 font-sans" dir="rtl">
                    {isHE ? (
                        <>
                            <h1
                                className="text-2xl mx-3 font-bold"
                                style={{ color: "#F88158" }}
                            >הופס בורדינג גייט</h1>
                            <h2 className="text-lg mt-2">
                                <span style={{ color: "#F88158" }}>
                                    היעד:

                                </span>
                                <span>
                                    <span>&nbsp;</span>
                                    <span
                                        className="bg-nba-gradient border-2 p-0.5 border-gray-600 rounded"
                                    >
                                        NBA
                                    </span>
                                </span>
                            </h2>
                            <div className="w-svw mt-5 md:w-5/6">
                                <p
                                    className="mx-5 mb-3 text-right tracking-tight text-sm text-white"
                                >
                                    האתר היחיד בעברית למידע על פרוספקטים של דראפט ה-NBA ועוד!
                                </p>
                            </div>
                        </>
                    ) : (
                        <div dir="ltr">
                            <h3
                                className="text-xl font-semibold mt-3"
                                style={{ color: "#F88158" }}
                            >Last Updates
                            </h3>
                            <ul className="text-white text-sm text-left ml-3 mt-5">
                            <li className="mb-3">
                                    <span className="font-bold">
                                        2.1.2025:
                                    </span>&nbsp;
                                    Kasparas Jakucionis's Profile added
                                </li>
                            <li className="mb-3">
                                    <span className="font-bold">
                                        2.1.2025:
                                    </span>&nbsp;
                                    Egor Demin's Profile added
                                </li>
                            <li className="mb-3">
                                    <span className="font-bold">
                                        30.12.24:
                                    </span>&nbsp;
                                    Ace Bailey's Profile added
                                </li>
                            <li className="mb-3">
                                    <span className="font-bold">
                                        22.12.24:
                                    </span>&nbsp;
                                    Cooper Flagg's Profile updated
                                </li>
                                <li className="mb-3">
                                <span className="font-bold">
                                        14.12.24:
                                    </span>&nbsp;
                                    Dylan Harper's Profile Updated
                                </li>
                                <li>
                                    <span className="font-bold">
                                        1.12.24:
                                    </span>&nbsp;
                                    Site launched with Ben Saraf's profile!
                                </li>
                            </ul>
                        </div>
                    )
                    }
                </div>
            </div>
            <div className="" dir={isHE ? "rtl" : "ltr"}>
                <div className="text-xs mt-3 text-white">
                    <a
                    href="mailto:contact@hoops-bg.net"
                    target="_blank"
                        rel="noopener noreferrer"
                    >
                        contact@hoops-bg.net
                    </a>
                </div>


            </div>
            <footer
                className="text-xs border-t border-gray-700 pt-2 text-white"
            >
                <div className="ms-3 mt-0.5">
                    <a
                        href="https://x.com/Hoops_BG"
                        target="_blank"
                        rel="noopener noreferrer"

                    >
                        <FaSquareXTwitter />
                    </a>
                </div>
                <div>
                    Terms and Agreements
                </div>
            </footer>
        </div>
       

    )
}

export default Homepage;